import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import { INSURANCE_CODE_MAX_LENGTH, INSURANCE_NAME_MAX_LENGTH } from '../../libraries/constants';
import { maximumSubString } from '../../libraries/utils';

const Form = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, title } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `code`,
              label: `Código`,
              required: true,
              changeHandler: maximumSubString(INSURANCE_CODE_MAX_LENGTH),
              formControlClass: classes.fullWidth
            })}

            {getInputField({
              ...fieldProps,
              name: `name`,
              label: 'Nombre',
              required: true,
              changeHandler: maximumSubString(INSURANCE_NAME_MAX_LENGTH),
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);
